import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { useEffect } from 'react';
import { MapContainer, Marker, TileLayer, useMap } from 'react-leaflet';

//@ts-ignore
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

//@ts-ignore
function ChangeView({ center }) {
  const map = useMap();

  useEffect(() => {
    map.setView(center, map.getZoom());
  }, [center, map]);

  return null;
}

interface Position {
  lat: number;
  lng: number;
}

interface MapProps {
  position: Position;
  onLocationChange: (position: Position) => void;
  disableInteraction?: boolean;
  zoom?: number;
  showMarker?: boolean;
}

//@ts-ignore
function DraggableMarker({ position, onLocationChange, disableInteraction }) {
  return (
    <Marker
      draggable={!disableInteraction}
      eventHandlers={{
        dragend: (e) => {
          if (!disableInteraction) {
            onLocationChange(e.target.getLatLng());
          }
        },
      }}
      position={position}
    />
  );
}

//@ts-ignore
function DisableInteractions({ disableInteraction }) {
  const map = useMap();

  useEffect(() => {
    if (disableInteraction) {
      map.dragging.disable();
      map.touchZoom.disable();
      map.doubleClickZoom.disable();
      map.scrollWheelZoom.disable();
      map.boxZoom.disable();
      map.keyboard.disable();
      //@ts-ignore
      if (map.tap) map.tap.disable();
    } else {
      map.dragging.enable();
      map.touchZoom.enable();
      map.doubleClickZoom.enable();
      map.scrollWheelZoom.enable();
      map.boxZoom.enable();
      map.keyboard.enable();
      //@ts-ignore
      if (map.tap) map.tap.enable();
    }
  }, [map, disableInteraction]);

  return null;
}

//@ts-ignore
function HideAttribution() {
  const map = useMap();

  useEffect(() => {
    const container = map.getContainer();
    const attributionControl = container.getElementsByClassName('leaflet-control-attribution')[0];
    if (attributionControl) {
      //@ts-ignore
      attributionControl.style.display = 'none';
    }
  }, [map]);

  return null;
}

export default function Map({ position, onLocationChange, disableInteraction = false, zoom = 13, showMarker = true }: MapProps) {
  return (
    <div className="lp-h-full lp-w-full">
      <MapContainer
        center={[position.lat, position.lng]}
        zoom={zoom}
        style={{ height: '100%', width: '100%' }}
        scrollWheelZoom={false}
        zoomControl={!disableInteraction}
        attributionControl={false}
      >
        <DisableInteractions disableInteraction={disableInteraction} />
        <HideAttribution />
        <ChangeView center={[position.lat, position.lng]} />
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          attribution=""
        />
        {showMarker && (
          <DraggableMarker
            position={position}
            onLocationChange={onLocationChange}
            disableInteraction={disableInteraction}
          />
        )}
      </MapContainer>
    </div>
  );
}
